export enum TransitionNavigationParameter {
  Propose = 3,
  Sandbox = 4,
}
